import React, { useState } from "react";
import { connect } from "react-redux";
import { presamisure, aggiornamisure } from "../../state/actions";

import Braccia from "../tutorial/braccia";
import Collo from "../tutorial/collo";
import Girovita from "../tutorial/girovita";
import Lunghezza from "../tutorial/lunghezza";
import Polso from "../tutorial/polso";
import Spalle from "../tutorial/spalle";
import Torace from "../tutorial/torace";

import Slider from "@mui/material/Slider";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const MisuraSlider = (props) => {
  const {
    lingua,
    tipo,
    sBraccia,
    sCollo,
    sGirovita,
    sLunghezza,
    sPolso,
    sSpalle,
    sTorace,
    setMisura,
  } = props;

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleInputChange = event => {
    setMisura([event.target.name], parseFloat(event.target.value))
  }

  let tipoTut = "corpo";
  switch (tipo) {
    case "corpo":
      tipoTut = "corpo";
      break;
    case "camicia":
      tipoTut = "camicia";
      break;
    default:
      tipoTut = "corpo";
      break;
  }

  return (
    <>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <p className="title is-6">{lingua.tutorial.braccia.titolo}</p>
        </AccordionSummary>
        <AccordionDetails>
          <Braccia lingua={lingua} tipoTut={tipoTut} />

          <Slider
            name="braccia"
            aria-label={lingua.navigazione.misure.Braccia}
            defaultValue={sBraccia}
            step={0.5}
            min={20}
            max={75}
            valueLabelDisplay="on"
            style={{color:"#e85e94"}}
            onChange={handleInputChange}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <p className="title is-6">{lingua.tutorial.collo.titolo}</p>
        </AccordionSummary>
        <AccordionDetails>
          <Collo lingua={lingua} tipoTut={tipoTut} />

          <Slider
            name="collo"
            aria-label={lingua.navigazione.misure.Collo}
            defaultValue={sCollo}
            step={0.5}
            min={35}
            max={55}
            valueLabelDisplay="on"
            style={{color:"#e85e94"}}
            onChange={handleInputChange}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <p className="title is-6">{lingua.tutorial.girovitaCamicia.titolo}</p>
        </AccordionSummary>
        <AccordionDetails>
          <Girovita lingua={lingua} tipoTut={tipoTut} />

          <Slider
            name="girovita"
            aria-label={lingua.navigazione.misure.Girovita}
            defaultValue={sGirovita}
            step={0.5}
            min={78}
            max={140}
            valueLabelDisplay="on"
            style={{color:"#e85e94"}}
            onChange={handleInputChange}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <p className="title is-6">{lingua.tutorial.lunghezza.titolo}</p>
        </AccordionSummary>
        <AccordionDetails>
          <Lunghezza lingua={lingua} tipoTut={tipoTut} />

          <Slider
            name="lunghezza"
            aria-label={lingua.navigazione.misure.Lunghezza}
            defaultValue={sLunghezza}
            step={0.5}
            min={60}
            max={100}
            valueLabelDisplay="on"
            style={{color:"#e85e94"}}
            onChange={handleInputChange}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <p className="title is-6">{lingua.tutorial.polso.titolo}</p>
        </AccordionSummary>
        <AccordionDetails>
          <Polso lingua={lingua} tipoTut={tipoTut} />

          <Slider
            name="polso"
            aria-label={lingua.navigazione.misure.Polso}
            defaultValue={sPolso}
            step={0.5}
            min={16}
            max={32}
            valueLabelDisplay="on"
            style={{color:"#e85e94"}}
            onChange={handleInputChange}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <p className="title is-6">{lingua.tutorial.spalle.titolo}</p>
        </AccordionSummary>
        <AccordionDetails>
          <Spalle lingua={lingua} tipoTut={tipoTut} />

          <Slider
            name="spalle"
            aria-label={lingua.navigazione.misure.Spalle}
            defaultValue={sSpalle}
            step={0.5}
            min={38}
            max={65}
            valueLabelDisplay="on"
            style={{color:"#e85e94"}}
            onChange={handleInputChange}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel7"}
        onChange={handleChange("panel7")}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <p className="title is-6">{lingua.tutorial.torace.titolo}</p>
        </AccordionSummary>
        <AccordionDetails>
          <Torace lingua={lingua} tipoTut={tipoTut} />

          <Slider
            name="torace"
            aria-label={lingua.navigazione.misure.Torace}
            defaultValue={sTorace}
            step={0.5}
            min={82}
            max={140}
            valueLabelDisplay="on"
            style={{color:"#e85e94"}}
            onChange={handleInputChange}
          />
        </AccordionDetails>
      </Accordion>
    </>
  );
};

function mapStateToProps(state) {
  return {
    sBraccia: state.shop.camicia.misure.braccia,
    sCollo: state.shop.camicia.misure.collo,
    sGirovita: state.shop.camicia.misure.girovita,
    sLunghezza: state.shop.camicia.misure.lunghezza,
    sPolso: state.shop.camicia.misure.polso,
    sSpalle: state.shop.camicia.misure.spalle,
    sTorace: state.shop.camicia.misure.torace,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setMisura: (nam, val) => dispatch(presamisure(nam, val)),
    aggMisure: (val) => dispatch(aggiornamisure(val)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MisuraSlider);
